import {apiBaseUrl} from '../../components/core/globalVariables';

async function fetchMetricDataSummaryNumeric({
  id,
  numericMetric,
  summary,
  kind,
  method,
  srid = 4326,
  feature_ids,
  timeseries_from,
  timeseries_to,
  globalRefs,
  globalState,
  timeseries_average
}) {

  const setLoggedInToAPI =
    globalState.setLoggedInToAPI;

  const setIsLoading =
    globalState.setIsLoading;

  const setisMenuLoadClick =
    globalState.setisMenuLoadClick;

  const debugMode =
    globalState.debugMode;

  try {

    const token =
      localStorage.getItem('token');

    if (!token) {
      throw new Error('No token in local storage');
    }

    const params = new URLSearchParams({
      srid: String(srid),
      kind,
      properties: numericMetric,
      method,

      ...(kind === 'timeseries' && {
        timeseries_from:
          new Date(timeseries_from).toISOString(),

        timeseries_to:
          new Date(timeseries_to).toISOString(),

        timeseries_average
      }),
    });

    const url =
      `${apiBaseUrl}/api/maps/${id}/features/summary?${params.toString()}`;

    const response = await fetch(
      url,
      {
        method: 'POST',

        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          feature_ids,
        }),
      }
    );

    if (!response.ok) {

      const errorText =
        await response.text();

      throw new Error(
        `Metric summary request failed: ${response.status} ${errorText}`
      );

    }

    const geoJsonData =
      await response.json();

    const timestamp =
      new Date().toISOString();

    if (debugMode) {

      console.log(
        timestamp +
        " " +
        "✅ fetching Key metric data"
      );

      console.log(geoJsonData);

    }

    return geoJsonData;

  } catch (error) {

    console.error(
      "❌ Error fetching metric data:",
      error
    );

    // setLoggedInToAPI(false);
    // setisMenuLoadClick(true);

    return null;

  }

}

export default fetchMetricDataSummaryNumeric;